export enum ImportSource {
    CSV_TEMPLATE = 'CSV_TEMPLATE',
    LQB = 'LQB',
    CSV_LEADS = 'CSV_LEADS',
    CSV_PARTNERS = 'CSV_PARTNERS',
    CANCELED = 'CANCELED'
}